/**
 * The floating pill at the foot of the screen: one shape, wherever it is drawn.
 *
 * The app's navigation lives in it, and a page's own controls borrow it (see
 * BottomNavProvider). A page with no navigation to borrow puts one up itself —
 * so the look is a constant rather than something copied between two files that
 * then drift apart the moment either is touched.
 *
 * Only the box: what is in it, how wide it ends up, and whether it is on a given
 * breakpoint are the caller's business.
 */
export const BOTTOM_PILL_CLASS = [
  // Centred by margin between two pinned edges, **not** by `left-1/2` and a
  // translate. That looks the same until the contents get wide: a fixed box with
  // only a left edge is laid out in what is left of the viewport from that edge
  // — half the screen — so anything wider than half is not made room for. It
  // spills out of the right of the pill (the last controls looking like they are
  // in some other box) and the translate then centres the *box*, which is no
  // longer where its contents are. Pinning both edges makes the whole viewport
  // the room available, and `w-fit` still shrinks to the contents.
  'fixed inset-x-0 z-40 mx-auto w-fit max-w-[calc(100vw-1rem)]',
  'bottom-[calc(0.75rem+env(safe-area-inset-bottom))]',
  'flex items-center p-1',
  'rounded-full border border-border',
  'bg-background/80 backdrop-blur-xl supports-[backdrop-filter]:bg-background/60',
  'shadow-[0_8px_30px_rgb(0,0,0,0.12)] dark:shadow-[0_8px_30px_rgb(0,0,0,0.4)]',
].join(' ');

/**
 * How long the pill takes to change hands. Short enough to feel like the same
 * object turning over rather than one thing leaving and another arriving.
 */
export const BOTTOM_PILL_SWAP_MS = 180;
